













































import request from 'axios';
import GlobalBus from '@/plugins/GlobalBus';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { ReCaptchaInstance } from '@/templates/gRecaptcha';
import { GlobalBusNames } from '@/templates/DataNames';
import { State } from 'vuex-class';

declare global {
  interface Window {
    captchaOnLoad: () => void;
    grecaptcha: ReCaptchaInstance;
  }
}

request.defaults.baseURL = process.env.VUE_APP_DOC_API_URL;

@Component({})
export default class Rating extends Vue {
  @Prop() modalId: string;
  @Prop({ default: '' }) pageId: string;
  @State pageRendered: boolean;

  public stars = 5;
  public feedbackIsSending = false;
  public successSend = false;
  public countSendingRequest = 0;
  private emailValue = '';
  private emailError = '';
  private emailState: boolean = null;
  private textAreaState: boolean = null;
  private selectedRating = -1;
  private ratingMessage = '';
  private hovered = -1;
  private modalClosing = false;
  private modalOpened = false;

  @Watch('pageRendered')
  onPageRendered(bool: boolean) {
    if (!bool) {
      this.hovered = -1;
      this.selectedRating = -1;
    }
  }

  mounted() {
    GlobalBus.on(GlobalBusNames.TAKERATING, this.pushRating);
  }

  beforeMount() {
    GlobalBus.off(GlobalBusNames.TAKERATING);
  }

  pushRating(obj: any) {
    if (this.pageId === obj.fqdn) this.selectedRating = obj.rating;
  }

  closeModal() {
    this.modalClosing = true;
    this.modalOpened = false;
    setTimeout(() => (this.modalClosing = false), 160);
  }

  sendGtmStar(star: number) {
    this.$sendGtmEvent({
      event: 'vox_docs_article_rate',
      category: 'article',
      action: 'rate',
      label: this.$router.currentRoute.path,
      value: star,
      noninteraction: false,
    });
  }

  public takeRating(star: number) {
    this.selectedRating = star;
    this.sendGtmStar(star);

    GlobalBus.emit(GlobalBusNames.TAKERATING, {
      fqdn: this.$route.meta.fqdn,
      rating: star,
    });
    if (star <= 3) {
      this.modalOpened = true;
    } else {
      this.sendFeedback();
      this.feedbackIsSending = true;
      setTimeout(() => {
        this.feedbackIsSending = false;
        this.successSend = true;

        setTimeout(() => (this.successSend = false), 600);
      }, 300);
    }
  }

  public sendFeedback() {
    if (this.selectedRating >= 3) {
      if (!this.emailState || !this.textAreaState) {
        if (this.emailState === null) this.validateEmail();
        if (this.textAreaState === null) this.textAreaState = false;

        return false;
      }
    }

    this.modalOpened = false;
    this.feedbackIsSending = true;
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute('6LexrqElAAAAAN8LzgfirBnWAZ-aB33E8fXrTr4q', { action: 'sendFeedback' })
        .then((token: string) => {
          request
            .post('ratePage', {
              url: this.$router.currentRoute.path,
              rate: this.selectedRating,
              message: this.ratingMessage,
              author_email: this.emailValue.trim(),
              recaptcha: token,
            })
            .then((response: any) => {
              if (response.data.result === 1) {
                this.feedbackIsSending = false;
                this.clearRatingMessage();
                this.successSend = true;
                setTimeout(() => (this.successSend = false), 1000);
              } else this.sendError(response, token);
            })
            .catch((error) => this.sendError(error, token));
        });
    });
  }

  sendError(response: any, token: string) {
    this.feedbackIsSending = false;
    this.successSend = true;
    this.countSendingRequest = 1;
    setTimeout(() => (this.successSend = false), 1000);
    setTimeout(() => {
      this.tryingToSendRequest(token);
    }, 3000);
    // this.clearRatingMessage()
  }

  tryingToSendRequest(token: string) {
    if (this.countSendingRequest >= 10) {
      this.countSendingRequest = 0;
      this.clearRatingMessage();
      return;
    }

    request
      .post('ratePage', {
        url: this.$router.currentRoute.path,
        rate: this.selectedRating,
        message: this.ratingMessage,
        author_email: this.emailValue,
        recaptcha: token,
      })
      .then((response: any) => {
        if (response.data.result === 1) {
          this.clearRatingMessage();
          this.countSendingRequest = 0;
        } else {
          this.countSendingRequest += 1;
          setTimeout(() => this.tryingToSendRequest(token), 3000);
        }
      })
      .catch((error) => {
        console.error('Error while trying to send request', error);
        this.countSendingRequest += 1;
        setTimeout(() => this.tryingToSendRequest(token), 3000);
      });
  }

  clearRatingMessage() {
    this.ratingMessage = '';
    this.emailValue = '';
  }

  public handleMouseEnter(index: number) {
    this.hovered = index;
  }

  public validateTextarea() {
    this.textAreaState = this.ratingMessage.length > 0;
  }

  public clearHovered() {
    this.hovered = -1;
  }

  public validateEmail() {
    // eslint-disable-next-line no-useless-escape
    let emailRegular = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,0-9;:\s@\"]{2,})$/i;
    let valid = emailRegular.test(this.emailValue.toString().toLowerCase());
    this.emailError =
      this.emailValue.length > 0 ? 'Enter a valid email' : 'The "email" field is required';
    this.emailState = valid;
  }

  setRatingClass(index: number) {
    return {
      'is-hovered': index <= this.hovered,
      'is-selected': index <= this.selectedRating,
    };
  }
}
